import Vue from 'vue'
import axios from 'axios'
import {_} from 'vue-underscore'

export const store = Vue.observable({
  status: {
    ready: false,
    busy: false,
    complete: false,
    error: false,
    message: ''
  },
  formData: {},
  invalidFields: [],
  config: false,
  token: ''
})

export const mutations = {
  setConfig (config) {
    store.config = config
  },
  setStatus (status) {
    if (status.key in store.status) {
      store.status[status.key] = status.value
    }
  },
  setFieldValue (data) {
    Vue.set(store.formData, data.key, data.value)
  },
  setToken (token) {
    store.token = token
  },
  addUploadedFile(data) {
    if (!(data.key in store.formData)) {
       Vue.set(store.formData, data.key, [])
    }
    store.formData[data.key].push(data.value)
  },
  removeUploadedFile(data) {
    let index = _.findIndex(store.formData[data.key], function(file) {
      return (file.id == data.value)
    })
    if (index != -1) {
      store.formData[data.key].splice(index, 1)
    }
  },
  setInvalidField (data) {
    let index = _.findIndex(store.invalidFields, function(item) {
      return (item.id == data.id)
    })
    if (index === -1) {
      store.invalidFields.push(data)
    }
  },
  setInvalidFields (fields) {
    store.invalidFields = fields
  },
  reset (bool) {
    if (bool === true) {
      store.invalidFields = []
      store.formData = {}
    }
  }
}

export const actions = {
  /** 
   * Initialise app
   */
  setup (data) {
    if (data.config && data.token != '') {
      mutations.setConfig(data.config)
      mutations.setToken(data.token)
      mutations.setStatus({ key: 'ready', value: true })
    } else {
      mutations.setStatus({ key: 'error', value: 'Cannot initialize form' })
    }
  },
  submit () {
    if (!store.status.busy) {
      mutations.setStatus({ key: 'busy', value: true })
      const url = store.config.url + '/submit/' + store.config.schema.id
      return axios.post(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        data: store.formData,
        token: store.token,
        responseType: 'json'
      })
    }
  },
  /**
   * Send http request
   * @param object options
   * @return object promise
   */
  sendRequest (options) {
    const request = {
      method: options.method,
      url: options.url,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      data: 'data' in options ? options.data : null,
      responseType: 'json'
    }

    return axios.request(request)
  }
}